<template>
  <div class="navbar">
    <hamburger :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />

    <breadcrumb class="breadcrumb-container" />

    <div class="right-menu">
          <div class="account-taggle">
            <el-dropdown size="medium" placement="bottom-start" trigger="click">
              <span class="el-dropdown-link" style="display:flex;">
                  <img v-if="doctype== 1" src="@/assets/cloud_logo.jpeg" />
                  <img v-if="doctype== 2" src="@/assets/mu_logo.jpeg"/>
                  <img v-if="doctype== 3" src="@/assets/hospital_logo.jpeg" />
                  <div>
                      <div style="height:20px;">{{userInfo.doctype == '3'?userInfo.hospitalname:userInfo.name}}</div>
                      <div>{{userInfo.doctype == '3'?userInfo.hospitalcode:userInfo.partnercode}}</div>
                  </div>
                  <i class="el-icon-arrow-down el-icon--right" style="line-height:34px;padding-left:20px;" />
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :divided="index>0?true:false" v-for="(item,index) of userType" :key="item.code" @click.native="handleRoutList(item.doctorid)">
                  <div class="orinaze">
                      <img v-if="item.doctype== 1" src="@/assets/cloud_logo.jpeg">
                      <img v-if="item.doctype== 2" src="@/assets/mu_logo.jpeg">
                      <img v-if="item.doctype== 3" src="@/assets/hospital_logo.jpeg">
                      <div style="height:40px;line-height:20px;">
                          <div>{{ item.name }}</div>
                          <div>{{ item.code}}</div>
                      </div>
                  </div>
                  </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
         <div class="personal">
              <el-dropdown trigger="click" placement="top-start">
                <span class="el-dropdown-link">
                    <el-avatar>{{iconName}}</el-avatar>
                    <i class="el-icon-arrow-down el-icon--right" style="position:absolute;left:23px;bottom:2px;" />
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item style="display:flex;">
                      <img src="@/assets/viewer.jpg"  style="width:16px;height:16px;margin:7px 7px 0 0"/>
                      <a  @click="readSettingVisible = true">专业阅片</a>
                  </el-dropdown-item>
                  <el-dropdown-item style="display:flex;">
                      <img src="@/assets/manual.png"  style="width:16px;height:16px;margin:7px 7px 0 0"/>
                      <a href="/static/remote-v1.0.0.pdf" target="_blank">用户手册</a>
                  </el-dropdown-item>
                   <el-dropdown-item style="display:flex;">
                      <img src="@/assets/about.png"  style="width:16px;height:16px;margin:7px 7px 0 0"/>
                      <a  @click="dialogVisible = true">关于我们</a>
                  </el-dropdown-item>
                  <el-dropdown-item style="display:flex;">
                      <img src="@/assets/loginout.png"  style="width:16px;height:16px;margin:7px 7px 0 0"/>
                      <a @click="logout">退出登录</a>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <span class="username">{{ userInfo.username }}</span>
              <span class="rolename">{{ userInfo.rolename }}</span>
         </div>
          <!-- 关于我们 -->
          <AboutUs :dialogVisible="dialogVisible" @closeDialog="closeDialog"/>
          <!-- 专业阅片设置 -->
          <ReadSetting :dialogVisible="readSettingVisible" @closeDialog="readSettingVisible=false;"/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import ErrorLog from '@/components/ErrorLog'
import Screenfull from '@/components/Screenfull'
import SizeSelect from '@/components/SizeSelect'
import LangSelect from '@/components/LangSelect'
import Search from '@/components/HeaderSearch'
import AboutUs from '@/components/AboutUs'
import ReadSetting from '@/components/ReadSetting'

import { queryDocType, setDocType,personalCenter } from '@/api/user'

export default {
  components: {
    Breadcrumb,
    Hamburger,
    ErrorLog,
    Screenfull,
    SizeSelect,
    LangSelect,
    Search,
    AboutUs,
    ReadSetting
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'name',
      'avatar',
      'username',
      "code",
      'typeName',
      'roleName',
      'doctype'
    ])
  },
  data() {
    return {
      dialogVisible:false,
      readSettingVisible:false,
      userInfo: {},
      userType: [],
      iconName:'user',
    }
  },
  created() {
    this.iconName = this.username.charAt(this.username.length-1);
  },
  mounted() {
    this.getUserInfo();
  },
  methods: {
    closeDialog(){
       this.dialogVisible = false
    },
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    logout() {
      this.$store
        .dispatch('user/logingout')
        .then(() => {
          this.$message({
            message: '退出登录成功',
            type: 'success'
          })
          this.$router.push('/login')
        })
    },
     getUserInfo(){
        personalCenter().then((res) => {
           this.userInfo = res.list?res.list[0]:{};
           this.getDoctorType();

      })
    },
    getDoctorType() {
      queryDocType().then(res => {
        this.userType = res.list?res.list:[];
      }).catch(error=>{
         console.log('catch:',error)
      })
    },
    handleRoutList(doctorid) {
      const params = {
        doctorid: doctorid
      }
      this.$store.dispatch('user/setDocType', this.qs.stringify(params)).then(() => {
        // 更新本地存储
        window.localStorage.setItem('store', JSON.stringify(this.$store.state))
        this.getUserInfo();
        this.$router.push({
          path: '/infoList',
          query: {
            doctorid: doctorid
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.logout{
  margin:0 30px;
  font-size:14px; 
}
.username{  
  margin-right:10px;
  display: inline-block;
}

.navbar {
  height: 60px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);

  .hamburger-container {
    line-height: 60px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background .3s;
    -webkit-tap-highlight-color:transparent;

    &:hover {
      background: rgba(0, 0, 0, .025)
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    // width: 400px;
    float: right;
    height: 100%;
    // line-height: 50px;
    display: flex;
    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background .3s;

        &:hover {
          background: rgba(0, 0, 0, .025)
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    } 
  }
}
.navbar {
  .account-taggle{
    .el-dropdown {
        border-right:1px solid #DBE0E8;
        padding-right:30px;
        margin-right:30px;
        height:20px;
        position:relative;
        top:20px;
        .el-dropdown-link {
            position:relative;
            top:-8px;
            img{
                width:40px;
                height:40px;
                margin-right: 10px;
            }
        }
    }
    
  }
  .personal{
    margin-right:50px;
    .el-avatar {
      position:relative;
      top:12px;
      right:10px;
      width:35px;
      height:35px;
      margin-right:10px;
      line-height:35px;
      background:#3397FD;
    }
    .rolename {
        color:rgba(0,0,0,0.25);
        border:1px solid rgba(0,0,0,0.25);
        font-size:12px;
        padding:2px 5px;
        border-radius:4px;
    }
  }
}



.el-dropdown-menu {
  position:relative;
  top:45px!important;
  padding: 0;
  border:none;
  max-height:600px;
  overflow-y: auto;
}


.orinaze{
  display:flex;
  margin:0;
   padding:14px 30px 14px 10px;
          margin:8px 6px 8px 6px; 
          border-radius:4px;
  img{
     width:40px;
     height:40px;
     margin-right:10px;
  }
}
.el-dropdown-menu--medium .el-dropdown-menu__item.el-dropdown-menu__item--divided{
  margin-top:9px;
  border: none;
}
.el-dropdown-menu__item--divided:before{
    content: '';
    height: 1px !important;
    display: block;
    margin: 0 !important;
    position: absolute;
    top: 17px;
    width: 84%;
    left: 8% !important;
    top: -5px;
    background-color: #DBE0E8;
}

:focus {outline: 0;}
</style>
